export const PREFIX = 'aaf_app_mundial_';

// Landing class names.
export const TEAMS = `${PREFIX}teams`;

// Login class names
export const CONTAINER = `${PREFIX}container`;

export const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio","Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",];
export const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

export const PRIMERTIEMPO = '1er tiempo';
export const SEGUNDOTIEMPO = '2do tiempo';

export const UNO = '1';
export const DOS = '2';
export const E = 'E';
export const MATCHDETAILINFO = 'match_detail_info_games_label_'

export const CARRUSELESINICIO = 'carruseles inicio';
export const CARRUSELESVCARD = 'carruseles vcard';
export const SELECCIONADOS = 'seleccionados';
export const SELECCIONADOSRELACIONADOS = 'seleccionados relacionados';
export const JUGADORESRELACIONADOS = 'jugadores relacionados';


//MUNDIAL
export const MUNDIAL2022 = 'mundial 2022';
export const URLVCARDEQUIPOS = '/mundial/vcard-equipo/'
export const URLEQUIPOS = '/node/mundial2022_equipos'

export const VCARDPARTIDO = 'vcardmatch'
export const VCARDEQUIPO = 'vcard-equipo'
export const VCARDJUGADOR = 'vcard-jugador'





// WEBPACK FOOTER //
// ./src/mundial/utls/constants.ts